import {
  CheckboxStyle,
  ContractIdTextStyle,
  ContractContentStyle,
  ResultItemStyle,
  TaxIdCountTextStyle,
} from '../ContractIdSelectionModal.style';
import type { ContractIdData } from '../types/ContractIdModal.types';

interface ContractIdResultItemProps {
  contract: ContractIdData;
  onToggle: (contractId: string) => void;
}

export function ContractIdResultItem({ contract, onToggle }: ContractIdResultItemProps) {
  return (
    <ResultItemStyle
      isDisabled={contract.isDisabled}
      role="option"
      aria-selected={contract.isSelected}
      aria-disabled={contract.isDisabled}
      onClick={() => !contract.isDisabled && onToggle(contract.contractId)}
    >
      <CheckboxStyle type="checkbox" checked={contract.isSelected} disabled={contract.isDisabled} readOnly />
      <ContractContentStyle>
        <ContractIdTextStyle>{contract.contractId}</ContractIdTextStyle>
        <TaxIdCountTextStyle>{contract.taxIdCount} Tax IDs</TaxIdCountTextStyle>
      </ContractContentStyle>
    </ResultItemStyle>
  );
}
